import { IonGrid, IonRow, IonCol, IonButton, IonLabel, IonSlides, IonSlide, IonInput, IonModal, IonItem, IonContent, IonLoading, IonIcon, IonFooter, IonHeader, IonText} from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect, useRef} from 'react';
import { trashOutline } from "ionicons/icons";

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from './TakePhoto';

import {v4 as uuid} from 'uuid';

import '../../../css/layout.css';

import { Preferences } from '@capacitor/preferences'


function addStorage_cart(event) {

    //alert("at Storage");
    //alert(event);

    Preferences.set({
        key: 'cartList',
        value: JSON.stringify(event),
        //value: [event[0], event[1], event[2], event[3],  event[4]].toString(),

    })
}

export function AddExpenseInvoiceModal (props) {

    let supplierNameRef = useRef('');
    let supplierPhoneRef = useRef('');
    let ingredientNameRef = useRef('');
    let expenseDescriptionRef = useRef('');
    let unitAmountRef = useRef('');
    let quantityRef = useRef('1');
    //let totalAmountRef = useRef();
    let paymentTypeRef = useRef('mobile_money');
    //let selectedFileRef = useRef('');

    let [ingredientName, setIngredientName] = useState("");

    let [quantity_state, setQuantity_state] = useState(1);
    let [paymentType_state, setPaymentType_state] = useState('mobile_money');

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [showPasswordModal, setShowPasswordModal] = useState(false); 
    let [showSupplierModal , setShowSupplierModal] = useState(false);
    let [supplerPhoneNumber , setSupplierPhoneNumber] = useState("N/A");

    //let [enteredPassword, setEnteredPassword] = useState('');
    let [searchResults, setSearchResults] = useState([]);
    let [searchResults_ingredients, setSearchResults_ingredients] = useState([]);

    let [takePhotoStatus, setTakePhotoStatus] = useState(false);
    let [selectedFile, setSelectedFile] = useState('/var/www/web/Public/fileServer/merchants/attachment-not-available.png');
    let [expenseInvoiceAttachement, setExpenseInvoiceAttachment] = useState('/var/www/web/Public/fileServer/merchants/attachment-not-available.png');

    let [isloading, setLoading] = useState(false);

    //let [supplierName, setSupplierName] = useState('');
    //let [supplierPhone, setSupplierPhone] = useState('');

    let [momo_provider, setMomoProvider] = useState('');
    let [momo_financial_transaction_id, setFinancialTransactionId] = useState(''); 
    let [momo_external_id, setExternalId] = useState('');
    let [momo_amount, setAmount] = useState('');
    let [momo_currency, setCurrency] = useState('');
    let [momo_party_id_type, setPartyIdType] = useState('');
    let [momo_party_id, setPartyId] = useState('');
    let [momo_payer_message, setPayerMessage] = useState('');
    let [momo_payee_note, setPayeeNote] = useState('');
    let [momo_pay_status, setPayStatus] = useState('');

    let [disableExpensePayButton, setDisableExpensePayButton] = useState(false);
    let [disableRefundButton, setDisableRefundButton] = useState(false);

    let [disablePayButton, setDisablePayButton] = useState(false);

    //let [selectedFile_upload, setSelectedFile_upload] = useState<File | null>(null);
    let [fileName, setFileName] = useState('');

    const [cartList, setCartList] = useState(authenticatedMerchent_context.cartList);
    let [cartSubtotal, setCartSubTotal] = useState(null);
    let [cartCheckoutTotal, setCartCheckoutTotal] = useState(null);
    let [internalReferenceID, setInternalReferenceID] = useState('');

    const blank = () => ({
        row_id: crypto.randomUUID(),   // unique key for React
        id: "",  
        name: "",
        description: "",
        price: "",
        quantity: ""
      });

    const [items, setItems] = useState([blank()]);

    const addLineItem = () => setItems(prev => [...prev, blank()]);

    const removeLineItem = (row_id) => {
        setItems(prev => {
          const next = prev.filter(i => i.row_id !== row_id);
          replaceCart(next);          // keep cartList in sync
          return next;
        });
      };

      const updateItem = (row_id, field, value) => {

        setItems(prev => prev.map(i => (i.row_id === row_id ? { ...i, [field]: value ?? "" } : i)));
      }
  

    function handleEnterAttachement() {  

        fetch(baseURL+'fileServer/merchants/attachment-not-available.png')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setExpenseInvoiceAttachment(noImageFile);

        })
    }

    function handleFileChange(event) {


        // alert("in HadndleFileChange");
        // alert(event);
        // alert(event.target);
        // alert(event.target.files);
        // alert(event.target.files[0]);

        const file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
        //setFileName(file ? file.name : '');
    }


    function addExpense(enteredPassword, expenseInvoiceID_source, expenseInvoiceID_target)
    {
        //let totalExpenseAmount = +unitAmountRef.current.value * +quantity_state;
        let totalExpenseAmount = cartCheckoutTotal;

        let formData = new FormData();
        formData.append('Tracker', '74002B');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('fmc_schema', schema);
        formData.append('xSupplierName', supplierNameRef.current.value);
        formData.append('xSupplierPhoneNumber', supplerPhoneNumber);
        //formData.append('xSupplierEmailAddress', supplierEmailAddressRef.current.value);
        //formData.append('xSupplierAddressNumber', supplierAddressNumberRef.current.value);
        //formData.append('xSupplierStreetName', supplierStreetNameRef.current.value);
        //formData.append('xSupplierCity', supplierCityRef.current.value);
        //formData.append('xSupplierCityDistrict', supplierCityDistrictRef.current.value);
        //formData.append('xSupplierCountryRegion', supplierCountryRegionRef.current.value);
        //formData.append('xSupplierCountry', supplierCountryRef.current.value);
        //formData.append('xSupplierDigitalAddressID', employeeDigitalAddressIDRef.current.value)
        formData.append('xExpenseDescription', JSON.stringify(cartList));
        formData.append('xExpenseUnitAmount', cartCheckoutTotal);
        formData.append('xExpenseQuantity', quantity_state);
        formData.append('xExpenseTotalAmount', totalExpenseAmount);
        formData.append('xPaymentType', paymentType_state);
        formData.append('xEnterAdminPassword', enteredPassword);
        formData.append('sessionID', sessionID);
        formData.append('xImageFile', selectedFile);
        formData.append('xInvoiceID', expenseInvoiceID_source);
        formData.append('xCustomerInvoiceID', expenseInvoiceID_target);
        formData.append('baseUrl', baseURL);


        const requestOptions = {
            enctype: 'multipart/form-data',
            credentials: 'include',
            method:'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        



       /* const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74002B',
                user: acctID,
                xSupplierName: supplierNameRef.current.value,
                xSupplierPhoneNumber: supplierPhoneRef.current.value,
                // xSupplierEmailAddress: supplierEmailAddressRef.current.value,
                // xSupplierAddressNumber: supplierAddressNumberRef.current.value,
                // xSupplierStreetName: supplierStreetNameRef.current.value,
                // xSupplierCity: supplierCityRef.current.value,
                // xSupplierCityDistrict: supplierCityDistrictRef.current.value,
                // xSupplierCountryRegion: supplierCountryRegionRef.current.value,
                // xSupplierCountry: supplierCountryRef.current.value,
                // xSupplierDigitalAddressID: employeeDigitalAddressIDRef.current.value,
                xExpenseDescription: expenseDescriptionRef.current.value,
                xExpenseUnitAmount: unitAmountRef.current.value,
                xExpenseQuantity: quantityRef.current.value,
                xExpenseTotalAmount: totalExpenseAmount,
                xPaymentType: paymentTypeRef.current.value,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,
                xSupportingDocumentation: selectedFile,

            })
        }*/

            let routePath;
            if(authenticatedMerchent_context.authenticated == 'T1')
            {
                routePath = 'hotel_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T2')
            {
                routePath = 'proService_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T3')
            {
                routePath = 'retail_merchantAcct_argsjqApp'
            }
        
            
        fetch(baseURL+routePath, requestOptions)
       .then(res => res.text())
        .then(data => {

            alert('Payment Sent To Customer');
            setDisableExpensePayButton(false);
            setLoading(false);
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }


    function searchSupplierList(event)
    {

        let searchCategory = event[0];
        let searchData = event[1];


        first_searchSuppliersInDB(searchCategory, searchData);


        /*let searchData;
        let optionsData;
        let list;

        if(searchCategory === 'name')
        {
            searchData = document.getElementById('searchSupplierName').value;
            optionsData = document.getElementById('searchSupplierNameList').childNodes;
            list = 'searchSupplierNameList';
        }
        else if(searchCategory === 'phone')
        {
            searchData = document.getElementById('searchSupplierPhoneNumber').value;
            optionsData = document.getElementById('searchSupplierPhoneNumberList').childNodes;
            list = 'searchSupplierPhoneNumberList';
        }



        for (let i = 0; i < optionsData.length; ++i)
        {

            if(optionsData[i].text === searchData)
            {

                supplierSearchResults(optionsData[i].dataset.id);
                break;
            }

            else if (i === optionsData.length - 1)
            {

                if (searchData.length > 1)
                {

                    searchSuppliersInDB(searchCategory, searchData, optionsData);
                }
                else if (searchData.length === 0)
                {

                    let optionsData = document.getElementById(list).childNodes;

                    for (let i = 0; i < optionsData.length; ++i)
                    {


                        let remove = document.getElementsByClassName('forRemoveProjectSearch');

                        while(remove.length > 0)
                        {
                            remove[0].parentNode.removeChild(remove[0]);
                        }
                    }

                    break;
                }
                else
                {

                    first_searchSuppliersInDB(searchCategory, searchData, optionsData);
                }
            }
        }*/
    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {
        //let searchData = document.getElementById('searchInventoryItem').value;
        //let optionsData = document.getElementById('searchInventoryItemsList').childNodes;


        /*for (let i = 0; i < optionsData.length; ++i)
        {
            let remove = document.getElementsByClassName('forDontRemoveProjectSearch');

            while(remove.length > 0)
            {
                remove[0].parentNode.removeChild(remove[0]);
            }
        }*/


        let formData = new FormData();
        let Tracker = '';


        if(searchCategory === 'name')
        {
            /*
            formData.append('Tracker', '74002S_N');
            formData.append('user', acctID);
            formData.append('xSupplierSearchName', searchData);
            */

            Tracker = '74002S_N';
        }
        else if(searchCategory === 'phone')
        {
             /*
            formData.append('Tracker', '74002S_P');
            formData.append('user', acctID);
            formData.append('xSupplierSearchPhone', searchData);
            */

            Tracker = '74002S_P';

        }
        else if(searchCategory === 'ingredient_name')
        {

            Tracker = '74002S_Ingredient';
        }

        /*const requestOptions = {
            method: 'POST',
            credentials: 'include',
            body: formData
        }*/

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xSearchData: searchData,
                sessionID: sessionID,
            })
        }

            let routePath;
            if(authenticatedMerchent_context.authenticated == 'T1')
            {
                routePath = 'hotel_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T2')
            {
                routePath = 'proService_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T3')
            {
                routePath = 'retail_merchantAcct_argsjqApp'
            }
        
            
        fetch(baseURL+routePath, requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                if(searchCategory === 'name')
                                {
                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_supplierId: cols[0],
                                            db_supplierName: cols[1],
                                            db_supplierPhoneNumber: cols[2],
                                            db_supplierAddressNumber: cols[3],
                                            db_supplierStreetName: cols[4],
                                            db_supplierCity: cols[5],
                                            db_supplierCountry: cols[6],
                                        })
                                    });
                                    //document.getElementById('searchSupplierNameList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+[cols[0], cols[1], searchCategory,]+'\'>'+cols[0]+'</option>'); // onclick=\'inventoryItemsSearchResults('+cols[0]+')\'
                                }
                                else if(searchCategory === 'phone')
                                {

                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            db_supplierId: cols[0],
                                            db_supplierName: cols[1],
                                            db_supplierPhoneNumber: cols[2],
                                            db_supplierAddressNumber: cols[3],
                                            db_supplierStreetName: cols[4],
                                            db_supplierCity: cols[5],
                                            db_supplierCountry: cols[6],
                                        })
                                    });
                                }
                                else if(searchCategory === 'ingredient_name')
                                {

                                    //alert("IN SEARCH RESULTS");
                                    //alert(cols);

                                    setSearchResults_ingredients((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            ingredientID: cols[0],
                                            ingredientName: cols[1],
                                            ingredientDescription: cols[2],
                                            ingredientPartNum: cols[3],
                                            ingredientVendorName: cols[4],
                                            ingredientPhoneNumber: cols[5],
                                            ingredientAddress: cols[6],
                                            ingredientCity: cols[7],
                                            ingredientCountry: cols[8],
                                            ingredientCostPerUnit: parseFloat(cols[9]).toFixed(2),
                                            //ingredientSalePrice: cols[10],
                                            ingredientQtyInStock: cols[10],
                                            ingredientMeasurementType: parseFloat(cols[11]).toFixed(2),
                                            ingredientDateCreated: parseFloat(cols[12]).toFixed(2),
                                            ingredientAddedBy: cols[13],
                                        })
                                    });
                                }
                            }
                    })
        }

    function paymentFunction(event)
    {

        //event.preventDefault();

        setDisableExpensePayButton(true);

        //alert(cartList[0]);
        //alert(cartList[0].id);
        //alert(cartList[0].name);

        const isBlank = (v) => v == null || (typeof v === "string" && v.trim() === "");
        const invalidNum = (v) => v == null || v === "" || isNaN(Number(v)) || Number(v) <= 0;
        
        const badItem = cartList.find(it =>
          isBlank(it.id) || isBlank(it.name) || invalidNum(it.price) || invalidNum(it.quantity)
        );

        if (badItem) {
          alert(`PRODUCT ${badItem.name} IS NOT IN THE SYSTEM. PLEASE SELECT PRODUCT FROM SYSTEM LIST.`);
          setDisableExpensePayButton(false);
          return;
        }

        const ok = window.confirm(`Proceed to pay ${cartCheckoutTotal} to ${supplierNameRef.current.value} via MTN MOMO number ${supplerPhoneNumber} ? `);
        if (!ok) 
        {
            setDisableExpensePayButton(false);
            return; // cancel
        }

        setLoading(true);

        if(event[5] == "partial_paid")
        {

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74108_B_expense_pay',
                    user: acctID,
                    xCustMobileNumber: event[0][1],
                    xInvoiceID: event[0][7],
                    xCustomerInvoiceID: event[0][8],
                    xImmediateDestination: acctID,
                    xCheckInCashAmount: parseFloat(event[0][0]).toFixed(2),
                    sessionID: sessionID,
                    xPaymentType: event[1],
                    xMomo_provider: event[2],
                    xMomo_financial_transaction_id: event[3],
                    xMomo_external_id: event[4],
                    xMomo_amount: event[5],
                    xMomo_currency: event[6],
                    xmomo_party_id_type: event[7],
                    xMomo_party_id: event[8],
                    xMomo_payer_message: event[9],
                    xMomo_payee_note: event[10],
                    xMomo_pay_status: event[11],
    
                }),
            }

            fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(data => {

                confirmPayment_non_member([data, event[0][1], event[0][2], event[0][3], event[0][4], event[0][6], event[1], event[2], event[3], event[4], event[5], event[6], event[7], event[8], event[9], event[10], event[11]]);

            })
            .catch(error => {
                console.error(error);
            })
        }
        else if(event[5] == "initial")
        { 
                const date = new Date();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
                const day = String(date.getDate()).padStart(2, '0');
                const year = date.getFullYear();

            const requestOptions0 = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74706_initial_expense',
                    user: acctID,
                    //xCheckInRoomID: event[0][6],
                    xSupplierName: event[2],
                    //xCheckInLastName: event[0][8],
                    xExpensePayMobileNumber: event[1],
                    xExpenseTotalAmount: parseFloat(event[0]).toFixed(2),
                    xExpensePayDateSent: `${month}/${day}/${year}`,
                    xPaymentType: "MTN-MOMO",
                    xExpenseInvoiceAttachment: expenseInvoiceAttachement,
                    xCartList: cartList,
                    xCartSubtotal: cartSubtotal,
                    xCartCheckoutTotal: cartCheckoutTotal,
                    xUserStatus: "non_member",
                    xCartLatitude: authenticatedMerchent_context.latitudeCurrent,
                    xCartLongitude: authenticatedMerchent_context.longitudeCurrent,
                    //xExpenseID: props.data.bookingID,
                    sessionID: sessionID,
                    
                }),
            }
    
            let routePath;
            if(authenticatedMerchent_context.authenticated == 'T1')
            {
                routePath = 'hotel_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T2')
            {
                routePath = 'proService_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T3')
            {
                routePath = 'retail_merchantAcct_argsjqApp'
            }
        
            
        fetch(baseURL+routePath, requestOptions0)
            .then(res => res.text())
            .then(data0 => {
    
                            let cols = data0.toString().split('|');

                            return new Promise((resolve, reject) => {

                                const customerPayAmount = parseFloat(event[0]).toFixed(2);
                                const payCurrency = 'GHS';
                                //const payExternalId = '';
                                const payPartyId = event[1].replace(/^0+/, '');
                                const payPayerMessage = event[2] + " Momo Payment";
                                const payPayeeNote = "Bluefin Hotel Invoice";
                    
                               //const apiuser = "28fd26ad-0cda-49a2-ad90-15083276a26a";
                                //const apikey = "218c665182e447538d0e6ac6f36ad3b4";
                                const apiuser = "0a8356fc-ce44-4436-a976-68a954d94094";
                                const apikey = "9070094e5ece4fabb351a0e282043cee";
                                const concatenatedString = `${apiuser}:${apikey}`;
                                const base64EncodedString = window.btoa(concatenatedString);
                    
                                let xReferenceID = uuid();
                                setInternalReferenceID(xReferenceID);
                    
                                fetch(baseURL+'mtnapi2/disbursement/token/', {
                                    method: 'POST',                                                                                                                                                                                                                 
                                    credentials: 'include',
                                    //mode: 'no-cors',
                                    //body: '',
                                    //Request headers
                                    headers: {
                                        'authorization': 'Basic '+ base64EncodedString,
                                        //'cache-Control': 'no-cache',
                                        //'content-_type': 'application/json',
                                        'ocp-apim-subscription-key': 'ff1585eb2f8a41d29771cca4238c02d3',
                                        'x-target-environment': 'mtnghana',
                                        'x-reference-id': xReferenceID.toString(),
                                        'x-internal-reference-id': xReferenceID.toString(),
                                        'user': acctID,
                                        'schema': schema,
                                        'x_user_status': 'non_member',    
                                        'x_merchant_mobilenumber': authenticatedMerchent_context.mtnCompanyPhoneNumber,    
                                        'x_project_id': 'N/A',
                                        'x_customer_mobilenumber': event[1],
                                        'x_invoice_id': cols[0],
                                        'x_customer_invoice_id': cols[1],
                                        'x_immediate_destination': acctID,
                                        'x_check_in_amount': parseFloat(event[0]).toFixed(2),
                                        'session_id': sessionID,
                                        'momo_url': 'disbursement/v1_0/'+event[4],
                                        'confirm_payment': 'confirm_or_reject',
                                        // 'request_to_pay': JSON.stringify({
                                        //     "amount": customerPayAmount,
                                        //     "currency": payCurrency,
                                        //     "externalId": xReferenceID.toString(),
                                        //     "payer": {
                                        //         "partyIdType": "MSISDN",
                                        //         "partyId": "233"+payPartyId
                                        //     },
                                        //     "payerMessage": payPayerMessage,
                                        //     "payeeNote": payPayeeNote
                                        // }),
                                        'customer_pay_amount': customerPayAmount,
                                        'pay_currency': payCurrency,
                                        'external_id': xReferenceID.toString(),
                                        'party_id_type': 'MSISDN',
                                        'party_id': payPartyId,
                                        'pay_payer_message': payPayerMessage,
                                        'pay_payee_note': payPayeeNote,
                    
                                    },
                    
                                })
                                .then(res => res.json())
                                .then(res => {
                                    
                                    if(res.status == "SUCCESSFUL")
                                    {

                                        const requestOptions = {
                                            method: 'POST',
                                            //credentials: 'include',
                                            headers: {
                                                'Accept': 'text/html, application/json',
                                                'content-type': 'application/json',
                                                //'cookie': 'cookie',
                                            },
                                            body: JSON.stringify({
                                                Tracker: '74108_B_expense_pay',
                                                user: acctID,
                                                xCustMobileNumber: event[1],
                                                xInvoiceID: cols[0],
                                                xCustomerInvoiceID: cols[1],
                                                xImmediateDestination: acctID,
                                                xCheckInCashAmount: parseFloat(event[0]).toFixed(2),
                                                sessionID: sessionID,
                                                xPaymentType: 'MTN-MOMO',
                                                xMomo_provider: 'MTN',
                                                xMomo_financial_transaction_id: res.financialTransactionId,
                                                xMomo_external_id: res.externalId,
                                                xMomo_amount: res.amount,
                                                xMomo_currency: 'GHS',
                                                xmomo_party_id_type: res.payee.partyIdType,
                                                xMomo_party_id: res.payee.partyId,
                                                xMomo_payer_message: res.payerMessage,
                                                xMomo_payee_note: res.payeeNote,
                                                xMomo_pay_status: res.status,           
                                                xInternalReferenceID: internalReferenceID,

                                            }),
                                        }
                
                                        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
                                        .then(res2 => res2.text())
                                        .then(res2 => {
                                            
                                            addExpense('reaper', cols[0], cols[1]);
                                            //confirmPayment_non_member([res2, event[1], event[2], cols[1], event[3], 'MTN-MOMO', 'MTN', res.financialTransactionId, res.externalId, res.amount, 'GHS', res.payee.partyIdType, res.payee.partyId, res.payerMessage, res.payeeNote, res.status]);
                
                                        })
                                        .catch(error => {
                                            console.error(error);
                                        })

                                    
                                    }
                                    else
                                    {
                                        alert('PAYMENT NOT SUCCESSFULL');
                                    }

                                })
                            })
    
                })
        }
        else if(event[5] == "admin")
        { 

                const date = new Date();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
                const day = String(date.getDate()).padStart(2, '0');
                const year = date.getFullYear();

            const requestOptions0 = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74706_initial_expense',
                    user: acctID,
                    //xCheckInRoomID: event[0][6],
                    xSupplierName: event[2],
                    //xCheckInLastName: event[0][8],
                    xExpensePayMobileNumber: event[1],
                    //xCheckInEmail: event[0][10],
                    //xCheckInNonMemberIDType: checkIn_Non_Member_ID_Type,
                    //xCheckInNonMemberIDNumber: enterID_numberRef.current.value,
                    //xSupportingDocumentation: selectedFile,
                    xExpenseInvoiceAttachment: expenseInvoiceAttachement,
                    xPaymentType: "MANUAL_MOMO_MTN",
                    xExpenseTotalAmount: parseFloat(event[0]).toFixed(2),
                    xExpensePayDateSent: `${month}/${day}/${year}`,
                    //xExpenseID: props.data.bookingID,
                    sessionID: sessionID,
                    xInternalReferenceID: internalReferenceID,

                }),
            }
    
            let routePath;
            if(authenticatedMerchent_context.authenticated == 'T1')
            {
                routePath = 'hotel_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T2')
            {
                routePath = 'proService_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T3')
            {
                routePath = 'retail_merchantAcct_argsjqApp'
            }
        
            
        fetch(baseURL+routePath, requestOptions0)
            .then(res => res.text())
            .then(data0 => {
    
                            let cols = data0.toString().split('|');

                            return new Promise((resolve, reject) => {

                                const customerPayAmount = parseFloat(event[0]).toFixed(2);
                                const payCurrency = 'GHS';
                                //const payExternalId = '';
                                const payPartyId = event[1].replace(/^0+/, '');
                                const payPayerMessage = event[2] + " Momo Payment";
                                const payPayeeNote = "Bluefin Hotel Invoice";
                    
                                const apiuser = "28fd26ad-0cda-49a2-ad90-15083276a26a";
                                const apikey = "218c665182e447538d0e6ac6f36ad3b4";
                                const concatenatedString = `${apiuser}:${apikey}`;
                                const base64EncodedString = window.btoa(concatenatedString);
                    
                                let xReferenceID = uuid();
                    
                    

                                        const requestOptions = {
                                            method: 'POST',
                                            //credentials: 'include',
                                            headers: {
                                                'Accept': 'text/html, application/json',
                                                'content-type': 'application/json',
                                                //'cookie': 'cookie',
                                            },
                                            body: JSON.stringify({
                                                Tracker: '74108_B_expense_pay',
                                                user: acctID,
                                                xCustMobileNumber: event[1],
                                                xInvoiceID: cols[0],
                                                xCustomerInvoiceID: cols[1],
                                                xImmediateDestination: acctID,
                                                xCheckInCashAmount: parseFloat(event[0]).toFixed(2),
                                                sessionID: sessionID,
                                                xPaymentType: 'MANUAL_MOMO_MTN',
                                                xMomo_provider: 'MTN',
                                                xMomo_financial_transaction_id: 'N/A',
                                                xMomo_external_id: xReferenceID,
                                                xMomo_amount: customerPayAmount,
                                                xMomo_currency: 'GHS',
                                                xmomo_party_id_type: 'MDSISDN',
                                                xMomo_party_id: payPartyId,
                                                xMomo_payer_message: payPayerMessage,
                                                xMomo_payee_note: payPayeeNote,
                                                xMomo_pay_status: 'SUCCESSFUL',           
                                                xInternalReferenceID: internalReferenceID,

                                            }),
                                        }
                
                                        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
                                        .then(res2 => res2.text())
                                        .then(res2 => {

                                            alert("BEFORE CONFIRM ADMIN PAY");
                                            alert(res2);

                                            confirmPayment_non_member([res2, event[1], event[2], cols[1], event[3], 'MANUAL_MOMO_MTN-MOMO', 'MTN', 'N/A', xReferenceID, customerPayAmount, 'GHS', 'MDSISDN', payPartyId, payPayerMessage, payPayeeNote, 'SUCCESSFUL', 'admin_pay', cols[0]]);
                
                                        })
                                        .catch(error => {
                                            console.error(error);
                                        })


                            })
    
                })
        }

    }


    function merchant_nonMember_update_transaction_status(event)
    {


        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74108_B_update',
                user: acctID,
                xCustMobileNumber: event[0][3],
                xInvoiceID: event[0][1],
                xCustomerInvoiceID: event[0][2],
                xImmediateDestination: acctID,
                xCheckInCashAmount: parseFloat(event[0][5]).toFixed(2),
                sessionID: sessionID,
                xMomo_provider: event[1],
                xMomo_financial_transaction_id: event[2],
                xMomo_external_id: event[3],
                xMomo_amount: event[4],
                xMomo_currency: event[5],
                xmomo_party_id_type: event[6],
                xMomo_party_id: event[7],
                xMomo_payer_message: event[8],
                xMomo_payee_note: event[9],
                xMomo_pay_status: event[10],
                xInternalReferenceID: internalReferenceID,

            }),
        }


            let routePath;
            if(authenticatedMerchent_context.authenticated == 'T1')
            {
                routePath = 'hotel_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T2')
            {
                routePath = 'proService_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T3')
            {
                routePath = 'retail_merchantAcct_argsjqApp'
            }
        
            
        fetch(baseURL+routePath, requestOptions)
        .then(res => res.text())
        .then(data => {

        })
        .catch(error => {
            console.error(error);
        })
    }

    function confirmPayment_non_member(event)
    {


        alert("INSIDE CONFIRM PAY");
        alert(event);

        let supplierName = event[2];
        let tracker = event[4];
        let customerInvoiceID = event[3];
        let transactionID = event[0];
        let customerPhoneNumber = event[1];

        /*
        let formData = new FormData();
        formData.append('Tracker', tracker);
        formData.append('xCustomerInvoiceID', customerInvoiceID);
        formData.append('xTransactionID', transactionID);
        formData.append('xCustMobileNumber', customerPhoneNumber);
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event[5]);

        const requestOptions = {
            method:'POST',
            credentials: 'include',
            body: formData
        }
        */
        alert("INSIDE CONFIRM PAY 2");

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: tracker,
                user: acctID,
                xCustomerInvoiceID: customerInvoiceID,
                xTransactionID: transactionID,
                xCustMobileNumber: customerPhoneNumber,
                xSupplierName: supplierName,
                sessionID: sessionID,
                xPaymentType: event[5],
                xMomo_provider: event[6],
                xMomo_financial_transaction_id: event[7],
                xMomo_external_id: event[8],
                xMomo_amount: event[9],
                xMomo_currency: event[10],
                xmomo_party_id_type: event[11],
                xMomo_party_id: event[12],
                xMomo_payer_message: event[13],
                xMomo_payee_note: event[14],
                xMomo_pay_status: event[15], 
                xInternalReferenceID: internalReferenceID,

            }),
        }

        alert("INSIDE CONFIRM PA 3Y");


        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {


                addExpense('reaper');
                alert('Payment Sent To Customer');
                alert(event[16]);

                if(event[16] == 'admin_pay')
                {
                    const requestOptions = {
                        method: 'POST',
                        //credentials: 'include',
                        headers: {
                            'Accept': 'text/html, application/json',
                            'content-type': 'application/json',
                            //'cookie': 'cookie',
                        },
                        url: '/momo_payment_confirmed',
                        body: JSON.stringify({
                            Tracker: '74108_B_update_successful_expense',
                            user: acctID,
                            xProjectID: 'N/A',
                            xCustMobileNumber: customerPhoneNumber,
                            xInvoiceID: event[17],
                            xCustomerInvoiceID: customerInvoiceID,
                            xImmediateDestination: acctID,
                            xCheckInCashAmount: event[9],
                            sessionID: sessionID,
                            xMomo_provider: event[6],
                            xMomo_financial_transaction_id: event[7],
                            xMomo_external_id: event[8],
                            xMomo_amount: event[9],
                            xMomo_currency: event[10],
                            xmomo_party_id_type: event[11],
                            xMomo_party_id: event[12],
                            xMomo_payer_message: event[13],
                            xMomo_payee_note: event[14],
                            xMomo_pay_status: event[15],   
                            xInternalReferenceID: internalReferenceID,
                                       
                            }),
                        }

                        fetch(baseURL+'momo_payment_confirmed', requestOptions)
                        .then(res => res.text())
                        .then(data => {

                            alert(data);

                        })

                }

        })
    }
    /*function takePhotoHandler() {


        setTakePhotoStatus(true);

        //const { takePhoto, photos } = TakePhoto();

        //setSelectedFile(photos[0].webviewPath);
    }*/


    function selectedFileHandler(event)
    {

        setSelectedFile(event);
       // setTakePhotoStatus(false);

    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        //setEnteredPassword(event);
        addExpense('reaper');
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    let timeout;

    function handleInput(event) {

        document.getElementById('searchSupplierNameList').innerHTML = '';
        //document.getElementById('searchSupplierPhoneNumberList').innerHTML = '';
        document.getElementById('searchIngredientNameList').innerHTML = '';

        clearTimeout(timeout); // Clear the previous timeout to reset the delay
        timeout = setTimeout(searchSupplierList(event), 2000); // Set a new timeout
    
    }
    
function replaceCart(newItems) {
    setCartList(newItems);
    authenticatedMerchent_context.changeCartList(newItems);
    addStorage_cart(newItems);
    //alert("All lines added to cart");
    //alert(newItems);
    }


const buildCart = (rows) =>
  rows
    .map(item => ({
      //row_id: item.row_id,
      id: item.id || "",
      name: (item.name || "").trim(),
      price: item.price || 0,
      quantity: Number(item.quantity) || 1,
    }))
    .filter(i => i.quantity > 0 && i.name);



useEffect(() => {

      //alert("IN USE EFFECT");
    //  alert(acctID);
      //alert(cartList);
      //alert(cartList.length);
     //alert(JSON.parse(cartList[0]));
     //alert(JSON.parse(cartList[0]).price);

    let cartSubtotal = 0;

    for (let rownum = 0; rownum < cartList.length; ++rownum)
    {
        //alert("IN SUBTOTAL");

        let cartItems = cartList[rownum];

        //alert(cartItems.name);
        //alert(cartItems.price);
        //alert(cartItems.quantity);

        cartSubtotal += cartItems.price * cartItems.quantity;

        //alert(cartSubtotal);


    }
    

    //let cartCheckoutTotal = cartSubtotal + (cartSubtotal * .15); //PLUS TAX
    let cartCheckoutTotal = cartSubtotal + (cartSubtotal * 0);

    //alert(cartSubtotal);
    //alert(cartCheckoutTotal);

    setCartSubTotal(cartSubtotal);
    setCartCheckoutTotal(cartCheckoutTotal);


}, [cartList])

useEffect(() => {
    replaceCart(buildCart(items));
  }, [items]);

function onIngredientPicked(event) {
    // do whatever you need with the selected result
    // e.g. add to cart, fetch details, etc.

    if (event[1] === "48") 
    {
        const note = window.prompt("Add a note for Services:", "");
        if (!note || note.trim() === "") {
          // user cancelled / empty note → bail (and keep button enabled)
          return;
        }
        alert(note);
       let description = `${event[2]} — ${note.trim()}`;
       //alert(description);
       //alert(event);

       updateItem(event[0], "id", event[1])
       updateItem(event[0], "name", description)
       updateItem(event[0], "description", description)
   
    }
    else if (event[1] === "51") 
    {
        const note = window.prompt("Add a note for Transportation:", "");
        if (!note || note.trim() === "") {
          // user cancelled / empty note → bail (and keep button enabled)
          return;
        }
        alert(note);
       let description = `${event[2]} — ${note.trim()}`;
       //alert(description);
       //alert(event);

       updateItem(event[0], "id", event[1])
       updateItem(event[0], "name", description)
       updateItem(event[0], "description", description)
   
    }
    else
    {
        //alert('in ingredientPiced');
        //alert(event);

        updateItem(event[0], "id", event[1])
        updateItem(event[0], "name", event[2])
        updateItem(event[0], "description", event[2])
    
    }
    //alert('PICKED');
    //alert(event);
    //alert(event[0]);
    //alert(event[1]);
    //alert(event[2]);

  }
  
  function handleSearchInput(category, e) {
    const val = e.target.value;
    //setIngredientName(val);
    //ingredientNameRef.current.value = val;
    // keep your existing behavior
  
    // when user clicks a suggestion, `val` will equal one of the names
    //alert("before side selected");

    const selected = searchResults.find(
      r => r.db_supplierName.toLowerCase() === val.toLowerCase()
    );
    if(selected && searchResults.length > 0) 
    {
        //alert("in side selected");
        //alert(selected);
        //alert(searchResults_ingredients.length);

        //onIngredientPicked([row_id, selected.ingredientID, selected.ingredientName]);
        //supplierNameRef.current.value = selected;

        setSupplierPhoneNumber(selected.db_supplierPhoneNumber);
        return; // ⬅️ stop here; do NOT call handleInput
    }

    //alert("under selected");

    handleInput([category, val]);
  }


  function handleDatalistInput(row_id, e) {
    const val = e.target.value;
    //setIngredientName(val);
    //ingredientNameRef.current.value = val;
    // keep your existing behavior
  
    // when user clicks a suggestion, `val` will equal one of the names
    //alert("before side selected");

    const selected = searchResults_ingredients.find(
      r => r.ingredientName.toLowerCase() === val.toLowerCase()
    );
    if(selected && searchResults_ingredients.length > 0) 
    {
        //alert("in side selected");
        //alert(selected);
        //alert(searchResults_ingredients.length);

        onIngredientPicked([row_id, selected.ingredientID, selected.ingredientName]);
        return; // ⬅️ stop here; do NOT call handleInput
    }
    else
    {
        //alert("in side NO SELECTION");

        updateItem(row_id, "id", "");
        updateItem(row_id, "name", e.target.value);
        updateItem(row_id, "description", e.target.value);

    }

    //alert("under selected");

    handleInput(["ingredient_name", val]);
  }

    function isJPEG(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            reader.onloadend = function() {
                const arr = new Uint8Array(reader.result).subarray(0, 4);
                let header = "";
                for (let i = 0; i < arr.length; i++) {
                    header += arr[i].toString(16);
    
                }
                
                // JPEG magic number: 0xFFD8
                if (header === "ffd8") {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
    
            reader.onerror = function() {
                reject(new Error("Error reading blob"));
            };
    
            reader.readAsArrayBuffer(blob.slice(0, 4));
        });
    }

    function onSubmitHandler(e) {
        e.preventDefault();
      
        const native = e.nativeEvent;
        const submitter = native.submitter; // inner <button>
      
        // 1) Try the inner <button> first (rarely has your data-attrs)
        let tracker = submitter?.dataset?.tracker;
        let method  = submitter?.dataset?.method;
        let stage   = submitter?.dataset?.stage;
      
        // 2) Fallback: walk the composed path to find the <ion-button> host
        if (!tracker || !method || !stage) {
          const path = typeof native.composedPath === "function" ? native.composedPath() : [];
          const host = path.find(el =>
            el && el.tagName && el.tagName.toUpperCase && el.tagName.toUpperCase() === "ION-BUTTON"
          );
          if (host) {
            tracker = tracker || host.getAttribute("data-tracker");
            method  = method  || host.getAttribute("data-method");
            stage   = stage   || host.getAttribute("data-stage");
          }
        }
      
        // 3) Optional defaults / error handling
        tracker ??= "74605_B_expense";
        method  ??= "transfer";
        stage   ??= "initial";
      
        paymentFunction([
          Number(cartCheckoutTotal) || 0,
          supplerPhoneNumber,
          supplierNameRef.current?.value?.trim() ?? "",
          tracker,
          method,
          stage
        ]);
      }

    useEffect(() => {

        setCartList([]);
        authenticatedMerchent_context.changeCartList([]);
        addStorage_cart([]);
  
  }, [])
    //alert('Inside AddExpense');

    return (

            <React.Fragment>
                {
                props.openModal == true ?
                (
                    <IonModal isOpen={ props.openModal }>
                    <form onSubmit={onSubmitHandler}>
                    <IonHeader style={{ color: "black" }}>
                        <IonGrid>
                            <IonRow>
                                <IonCol>
                                    <h3>ADD EXPENSE</h3>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    <IonContent className='grid_content'>

                                <IonGrid>
                                    <IonRow>
                                        <IonCol>
                                            <IonText>SUPPLIER</IonText>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonText className='professional-text'>NAME:</IonText>
                                        </IonCol>
                                        <IonCol>
                                            <input type='text' id='searchSupplierName' ref={ supplierNameRef } placeholder='Search name' onInput={(e) => handleSearchInput('name', e)} list='searchSupplierNameList' autocomplete='off' required></input>
                                            <datalist id='searchSupplierNameList'>
                                                {searchResults.map((result) => (
                                                    <option key={result.db_supplierId} value={result.db_supplierName}></option>
                                                ))}
                                            </datalist>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonText className='professional-text'>MTN MOMO:</IonText>
                                        </IonCol>
                                        <IonCol>
                                            <input type='text' id='searchSupplierPhoneNumber' value={ supplerPhoneNumber }  placeholder='Enter supplier phoneNumber' onInput={(e) => setSupplierPhoneNumber(e.target.value)}autocomplete='off' required></input>
                                            {/*<datalist id='searchSupplierPhoneNumberList'>
                                                {searchResults.map((result) => (
                                                    <option key={result.db_supplierId} value={result.db_supplierPhoneNumber}></option>
                                                ))}
                                                </datalist>*/}
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonText className='professional-text'>CART TOTAL: {parseFloat(cartCheckoutTotal).toFixed(2)} GHS</IonText>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonButton onClick={addLineItem}>Add Line Item</IonButton>
                                        </IonCol>
                                    </IonRow>
                                    {items.map((item) => (
                                        <IonRow key={item.row_id}>
                                        <IonCol size="4">
                                            {/*<IonInput
                                            className="professional-input"
                                            type="text"
                                            placeholder="Name"
                                            value={item.name}
                                            onIonInput={e => updateItem(item.id, "name", e.target.value)}
                                            required
                                            autocomplete="off"
                                            />*/}

                                            <input className="professional-input" type='text' id='searchIngredientName' ref={ ingredientNameRef } placeholder='Search name' onInput={e => handleDatalistInput(item.row_id, e)} list='searchIngredientNameList' autocomplete='off' required></input>
                                            <datalist id='searchIngredientNameList'>
                                                {searchResults_ingredients.map((result) => (
                                                    <option key={result.ingredientID} value={result.ingredientName}></option>
                                                ))}
                                            </datalist>
                                        </IonCol>
                                        {/*<IonCol size="3">
                                            <IonInput
                                            className="professional-input"
                                            type="text"
                                            placeholder="Description"
                                            value={item.description}
                                            onIonInput={e => updateItem(item.id, "description", e.detail.value)}
                                            required
                                            autocomplete="off"
                                            />
                                        </IonCol>*/}
                                        <IonCol size="3">
                                            <IonInput
                                            className="professional-input"
                                            type="number"
                                            step="any"
                                            placeholder="Price"
                                            value={item.price}
                                            onIonInput={e => updateItem(item.row_id, "price", e.target.value)}
                                            required
                                            autocomplete="off"
                                            />
                                        </IonCol>
                                        <IonCol size="3">
                                            <IonInput
                                            className="professional-input"
                                            type="number"
                                            placeholder="Quantity"
                                            value={item.quantity}
                                            onIonInput={e => updateItem(item.row_id, "quantity", e.target.value)}
                                            required
                                            autocomplete="off"
                                            />
                                        </IonCol>
                                        <IonCol size="2" className="ion-text-right">
                                            <IonButton fill="clear" color="danger" onClick={() => removeLineItem(item.row_id)}>
                                            <IonIcon icon={trashOutline} />
                                            </IonButton>
                                        </IonCol>
                                        </IonRow>
                                    ))}

                                    {/*<IonRow>
                                        <IonCol>
                                        <IonButton
                                            onClick={() => {
                                                const newCart = items
                                                .map(item => ({
                                                    id: item.id,
                                                    name: item.name,
                                                    price: item.price || 0,
                                                    quantity: Number(item.quantity) || 1,
                                                }))
                                                // optional guards:
                                                .filter(i => i.quantity > 0);

                                                replaceCart(newCart);
                                            }}
                                            >
                                            Add All Lines to Cart
                                        </IonButton>
                                        </IonCol>
                                        </IonRow>*/}
                                    <IonRow>
                                        <IonCol size="12" sizeMd="5">                            
                                            <IonButton  onClick={() => setTakePhotoStatus(true)}> Photo</IonButton>
                                            {takePhotoStatus == true && <TakePhoto onSelectedFile={selectedFileHandler}></TakePhoto>}

                                            <input
                                                type="file"
                                                accept="image/jpeg"
                                                onChange={handleFileChange}
                                            />
                                        </IonCol>
                                    </IonRow>
                                    {/*<IonRow>
                                        <form id='fileUpload' onSubmit={() => setShowPasswordModal(true)}>
                                            <input type='file' name='xImageFile' accept="image/*" enctype='multipart/form-data' onChange={(e) => setSelectedFile(e.target.files[0])}></input>
                                        </form>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <label for='noAttachment'>No Attachment</label>
                                        </IonCol>
                                        <IonCol>
                                            <input type='checkbox' id='noAttachment' onClick={() => handleEnterAttachement()}></input>
                                        </IonCol>
                                    </IonRow>*/}
                                </IonGrid>
                        {/*<EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>*/}                        
                        {/*<IonButton onClick={() => setShowPasswordModal(true)}> Add Expense </IonButton>*/}


                        {isloading == true && <IonLoading
                            isOpen={isloading}
                            message={'Please wait...'}
                            duration={0} // Show until manually dismissed
                        />}

                        {/*<AddSupplierModal  openModal={ showSupplierModal } closeModal={() => setShowSupplierModal(false)}></AddSupplierModal>*/}

                        </IonContent>
                        <IonFooter className='grid_footer'>
                            <IonGrid>
                            { (authenticatedMerchent_context.accessRights[0] == 'manager' || authenticatedMerchent_context.accessRights[0] == 'restaurant_kitchen') && 
                                <IonRow>
                                    <IonCol size='6'>
                                    <IonButton type='submit' disabled={disableExpensePayButton} data-tracker="74605_B_expense" data-method="transfer" data-stage="initial"> Transfer </IonButton>
                                    </IonCol>
                                    <IonCol size='6'>
                                        <IonButton  onClick={() => closeModalHandler(false)}>Cancel </IonButton>
                                    </IonCol>
                                </IonRow>}
                            {authenticatedMerchent_context.accessRights[0] == 'admin'  &&
                                <IonRow>
                                    <IonCol size='4'>
                                    <IonButton type='submit' disabled={disableExpensePayButton} data-tracker="74605_B_expense" data-method="transfer" data-stage="initial"> Transfer </IonButton>
                                    {/* <IonButton id='gridResultColumnButton' disabled={disableExpensePayButton} onClick={() => paymentFunction([unitAmountRef.current.value, supplierPhoneRef.current.value, supplierNameRef.current.value, '74605_B_expense', 'deposit', 'initial'])}> Deposit </IonButton>} */}
                                    </IonCol>
                                    <IonCol size='4'>
                                    <IonButton type='submit' disabled={disableExpensePayButton} data-tracker="74605_B_expense" data-method="transfer" data-stage="admin"> Admin </IonButton>
                                    </IonCol>
                                    <IonCol size='4'>
                                        <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
                                    </IonCol>
                                </IonRow>}
                            </IonGrid>
                        </IonFooter>
                        </form>
                    </IonModal>) : null
                }
            </React.Fragment>

    )
}